var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isLoading ? _c('loading') : _vm._e(), _c('div', {
    staticClass: "container pb-5"
  }, [_c('div', {
    staticClass: "map position-relative"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/hero.jpg")
    }
  }), _vm._l(_vm.tags, function (tag) {
    return [_c('img', {
      key: tag,
      staticClass: "img-fluid badge-img",
      attrs: {
        "src": _vm.imgPath(tag)
      }
    })];
  })], 2), _c('div', {
    staticClass: "body text-center"
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_c('div', [_vm._v("已經成功探索過"), _c('span', {
    staticClass: "number mx-2"
  }, [_vm._v(_vm._s(_vm.collectCount))]), _vm._v("大節慶")]), _c('div', [_vm._v("集滿" + _vm._s(_vm.totalCount) + "枚徽章就能抽")]), _c('div', [_vm._v("「隨興聽Bar藍牙音箱」")]), _c('div', [_vm._v("繼續加油吧！")])]), _c('img', {
    staticClass: "img-fluid mt-3",
    attrs: {
      "src": require("./images/bar.png")
    }
  }), _vm.isCompleted ? _c('a', {
    staticClass: "btn button",
    on: {
      "click": function click($event) {
        return _vm.gotToCompletedUrl();
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid mt-3",
    attrs: {
      "src": require("./images/button.png")
    }
  })]) : _vm._e(), !_vm.isCompleted ? _c('a', {
    staticClass: "btn button disabled",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-fluid mt-3",
    attrs: {
      "src": require("./images/button-disabled.png")
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "info text-white text-left px-4 py-3 m-4"
  }, [_c('h5', {
    staticClass: " text-center font-weight-bold",
    domProps: {
      "innerHTML": _vm._s(_vm.extraTitleText)
    }
  }), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.extraDescText)
    }
  })]), _vm._m(0)])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "fixed-bottom"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/warning.jpg")
    }
  })]);
}]

export { render, staticRenderFns }